// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* wrapper around an input, label, and error status */
.XfyYs9GQjvbVSH4DtBAP {
  margin-bottom: 20px;
}

.VVLJBb2i1U3Y7DMpJPzQ {
  font-size: 14px;
  line-height: 18px;
  color: #32445A;
  font-weight: 600;
}

.VVLJBb2i1U3Y7DMpJPzQ.dVaZ4Jd_uFdOsgEKxPg_, .L_U8EWrLXMvERtZOwbAC {
  margin-left: 8px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"]};
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/haven-design/form/form.module.css"],"names":[],"mappings":"AAGA,qDAAqD;AACrD;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mDAAe;EACf,gBAAgB;AAClB","sourcesContent":["@value colors: \"../../../styles/colors.module.css\";\n@value hc-outline, hc-error from colors;\n\n/* wrapper around an input, label, and error status */\n.inputGroup {\n  margin-bottom: 20px;\n}\n\n.label {\n  font-size: 14px;\n  line-height: 18px;\n  color: #32445A;\n  font-weight: 600;\n}\n\n.label.error, .labelError {\n  margin-left: 8px;\n  color: hc-error;\n  font-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../styles/colors.module.css"`,
	"hc-outline": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"]}`,
	"hcOutline": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"]}`,
	"hc-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"]}`,
	"hcError": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"]}`,
	"inputGroup": `XfyYs9GQjvbVSH4DtBAP`,
	"label": `VVLJBb2i1U3Y7DMpJPzQ`,
	"error": `dVaZ4Jd_uFdOsgEKxPg_`,
	"labelError": `L_U8EWrLXMvERtZOwbAC`
};
export default ___CSS_LOADER_EXPORT___;
